import React from "react";
import {withRouter} from "react-router-dom";
import {Link} from "@mui/material";
import {router} from "@atttomyx/react-utils";
import {PAGE_HELPS} from "../../constants";

const QuestionsLink = (props) => {
    const { history } = props;

    return <Link onClick={() => router.redirectTo(history, PAGE_HELPS)}>questions</Link>
};

export default withRouter(QuestionsLink);
